import axios from 'axios'

class ShareRecordService {
  constructor() {
    this.baseUrl = '/api/v1/'
  }

  verifyRecipientInfo(data) {
    return axios.post(
      `${this.baseUrl}sharing/validate-recipient-details/`,
      data
    )
  }

  getRecipientRelationshipDuration() {
    return axios.get(
      `${this.baseUrl}sharing/get-recipient-relationship-duration/`
    )
  }

  saveRecipientInformation(data) {
    return axios.post(`${this.baseUrl}sharing/save-recipient-details/`, data)
  }

  getQRCode() {
    return axios.post(`${this.baseUrl}qr/save-qr-recipient-details/`, {})
  }
}

export const shareRecordService = new ShareRecordService()
